import { IconApps, IconCheck, IconClose } from './icons';
import type { MobileBusinessApp } from '../types';

type Props = { open: boolean; apps: MobileBusinessApp[]; currentCode: string; onSelect: (code: string) => void; onClose: () => void };

export default function MobileApplicationSwitcher(props: Props) {
  if (!props.open) return null;
  return <div className="mobile-sheet-layer">
    <button className="mobile-sheet-scrim" type="button" aria-label="关闭应用切换" onClick={props.onClose} />
    <section className="mobile-platform-sheet mobile-application-switcher" role="dialog" aria-modal="true" aria-label="切换应用">
      <div className="mobile-platform-sheet__head"><strong>切换应用</strong><button className="mobile-icon-button" type="button" aria-label="关闭应用切换" onClick={props.onClose}><IconClose /></button></div>
      <div className="mobile-application-switcher__list">{props.apps.map((app) => <button type="button" key={app.code} aria-pressed={props.currentCode === app.code} onClick={() => props.onSelect(app.code)}><IconApps /><span><strong>{app.name}</strong><small>{app.description}</small></span>{props.currentCode === app.code ? <IconCheck /> : null}</button>)}</div>
    </section>
  </div>;
}
